import { fetchAdminCustomers, fetchAdminOverview, fetchAdminSpend, fetchCustomerDashboard } from './api'
import { useQuery } from '@tanstack/react-query'
import { PeriodQuery } from './dashboard'

function hasPeriod({ start, end }: PeriodQuery) {
    return typeof start !== 'undefined' && typeof end !== 'undefined'
}

export function useAdminOverview(query: PeriodQuery) {
    return useQuery({
        queryFn: () => fetchAdminOverview(query),
        queryKey: ['admin-dashboard', 'overview', query.start, query.end],
        enabled: hasPeriod(query),
    })
}

export function useAdminCustomers(query: PeriodQuery) {
    return useQuery({
        queryFn: () => fetchAdminCustomers(query),
        queryKey: ['admin-dashboard', 'customers', query.start, query.end],
        enabled: hasPeriod(query),
    })
}

export function useAdminSpend(query: PeriodQuery) {
    return useQuery({
        queryFn: () => fetchAdminSpend(query),
        queryKey: ['admin-dashboard', 'spend', query.start, query.end],
        enabled: hasPeriod(query),
    })
}

export function useCustomerDashboard({ enabled = false }: { enabled?: boolean }) {
    return useQuery({
        queryFn: () => fetchCustomerDashboard(),
        queryKey: ['dashboard'],
        enabled,
    })
}
